import { useEffect, useState } from "react";
import { useSynthwave } from "@/lib/store/synthwave-store";

export function SynthwaveBackground() {
  const { isSynthwaveEnabled } = useSynthwave();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check initial dark mode state
    const checkDarkMode = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    checkDarkMode();

    // Watch for dark mode changes
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  // Only show if synthwave is enabled and dark mode is on
  if (!isSynthwaveEnabled || !isDark) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
      {/* Synthwave gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            linear-gradient(to bottom,
              #0a0a1a 0%,
              #1a0a2e 15%,
              #2d1b4e 30%,
              #3d2a5e 45%,
              #4a3a6e 60%,
              #3d2a5e 75%,
              #2d1b4e 90%,
              #1a0a2e 100%
            )
          `,
        }}
      />

      {/* Animated grid lines */}
      <div className="absolute inset-0 opacity-40 grid-layer-1" />
      <div className="absolute inset-0 opacity-30 grid-layer-2" />

      {/* Horizon line with glow */}
      <div
        className="absolute bottom-0 left-0 right-0 h-1"
        style={{
          background: "linear-gradient(to right, transparent, #ff00ff, #00ffff, #ff00ff, transparent)",
          boxShadow: "0 0 20px #ff00ff, 0 0 40px #ff00ff",
        }}
      />

      {/* CSS for animations */}
      <style>{`
        .grid-layer-1 {
          background-image: 
            linear-gradient(rgba(255, 0, 255, 0.5) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 0, 255, 0.5) 1px, transparent 1px);
          background-size: 50px 50px;
          background-position: 0 0;
          animation: gridMove1 6s linear infinite;
          will-change: background-position;
          transform: translate3d(0, 0, 0);
          backface-visibility: hidden;
        }

        .grid-layer-2 {
          background-image: 
            linear-gradient(rgba(0, 255, 255, 0.4) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 255, 255, 0.4) 1px, transparent 1px);
          background-size: 100px 100px;
          background-position: 0 0;
          animation: gridMove2 10s linear infinite reverse;
          will-change: background-position;
          transform: translate3d(0, 0, 0);
          backface-visibility: hidden;
        }

        @keyframes gridMove1 {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 50px 50px;
          }
        }

        @keyframes gridMove2 {
          0% {
            background-position: 0 0;
          }
          100% {
            background-position: 100px 100px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .grid-layer-1,
          .grid-layer-2 {
            animation: none !important;
          }
        }
      `}</style>
    </div>
  );
}

